import { createRouter, createWebHistory } from "vue-router";

import Home from "./views/Home.vue";
import Opener from "./views/Opener.vue";
import Privacy from "./views/Privacy.vue";
import Terms from "./views/Terms.vue";
import Support from "./views/Support.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: Home,
      name: "Home",
    },
    {
      path: "/open",
      component: Opener,
      name: "Opener",
    },
    {
      path: "/privacy",
      component: Privacy,
      name: "Privacy",
    },
    {
      path: "/terms",
      component: Terms,
      name: "Terms",
    },
    {
      path: "/support",
      component: Support,
      name: "Support",
    },
    {
      path: "/:catchAll(.*)",
      redirect: "/",
    },
  ],
});

export default router;
